import type { IconOption } from '@/pages/onboarding/onboarding.types';
import type { ConsultationType, Profession, SessionMode, Specialty } from '@/types/onboarding';

export const PROFESSION_OPTIONS: IconOption<Profession>[] = [
  { value: 'doctor', icon: 'Stethoscope' },
  { value: 'nurse', icon: 'HeartPulse' },
  { value: 'physiotherapist', icon: 'Activity' },
  { value: 'psychologist', icon: 'Brain' },
  { value: 'midwife', icon: 'Baby' },
  { value: 'occupational_therapist', icon: 'Hand' },
  { value: 'speech_therapist', icon: 'AudioLines' },
  { value: 'dietitian', icon: 'Apple' },
  { value: 'social_worker', icon: 'HeartHandshake' },
  { value: 'other', icon: 'Plus' },
];

export const SPECIALTY_OPTIONS: Specialty[] = [
  'general_practice',
  'general_medicine',
  'psychiatry',
  'pediatrics',
  'internal_medicine',
  'dermatology',
  'gynecology',
  'orthopedics',
  'other',
];

export const CONSULTATION_OPTIONS: IconOption<ConsultationType>[] = [
  { value: 'in_person', icon: 'Building2' },
  { value: 'phone', icon: 'Phone' },
  { value: 'video', icon: 'Video' },
  { value: 'home_visit', icon: 'House' },
];

export const SESSION_MODE_OPTIONS: IconOption<SessionMode>[] = [
  { value: 'conversation', icon: 'MessagesSquare' },
  { value: 'dictation', icon: 'Mic' },
  { value: 'both', icon: 'Repeat' },
];

/** Step each summary row's "Breyta" jumps back to. */
export const PROFESSION_STEP = 1;
export const WORK_STEP = 2;
export const DETAIL_STEP = 3;

/** Narrows a primitive's string value back to one of the known options. */
export const matchOption = <T extends string>(options: readonly T[], value: string): T | undefined =>
  options.find((option) => option === value);
